import React, { useCallback, memo, useMemo } from 'react';
import { useDispatch } from "react-redux";
import Cell from './cell';
import { reactOnAssignedItem } from '../../../../store/actions/accountReceivableActions/accountReceivableActions';

const Row = ({
        data,
        style,
        itemSize,
        listRef,
        startOnScroll,
        resource,
        priceTemplateType,
        customerId,
        mainScroll,
        checked,
        setCheckedList,
        }) => {
    const dispatch = useDispatch();
    const color = data.rowState.type === 'load' ? '#65A7A5' : data.rowState.type === 'stop' ?  '#D9EBEB' : 'white';

    const onClickRow = useCallback(() => {
        dispatch(reactOnAssignedItem(resource, data.rowState.id, data.rowState.type));
    }, [dispatch, resource, data.rowState.id, data.rowState.type]);

    const rowStyle = useMemo(() => ({
        ...style,
        width: 'max-content',
        height: `${itemSize}px`,
        backgroundColor: color,
        display: 'flex',
    }), [style, itemSize, color]);
    
    const cellContent = useCallback((i, ind) => (
        <Cell
            key={ind}
            cellData={i}
            reacted={data.rowState.reacted}
            type={data.rowState.type}
            itemSize={itemSize}
            onClickRow={onClickRow}
            startOnScroll={startOnScroll}
            rowState={data.rowState}
            resource={resource}
            priceTemplateType={priceTemplateType}
            customerId={customerId}
            mainScroll={mainScroll}
            checked={checked}
            setCheckedList={setCheckedList}
        />
    ), [data.rowState, itemSize, onClickRow, startOnScroll, resource, priceTemplateType, customerId, mainScroll, checked, setCheckedList]);

    if (!data) return null;
    return (
        <div className='resp-table-row' style={rowStyle}>
            {data.row.map(cellContent)}
        </div>
    );
};

export default memo (Row);